import { Union } from "../fable_modules/fable-library.3.7.20/Types.js";
import { string_type, union_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { isSQLBoolean as isSQLBoolean_1, is_yyyy_mm_dd_hh_mm_ss as is_yyyy_mm_dd_hh_mm_ss_1, is_yyyy_mm_dd as is_yyyy_mm_dd_1, isOnlyNumberWithPossibleDecimals as isOnlyNumberWithPossibleDecimals_1, isValidPeppolId, isOnlyPositiveInteger, isOnlyTextAndWhitespace as isOnlyTextAndWhitespace_1, isOnlyNumbers as isOnlyNumbers_1, isValidEmail as isValidEmail_1, isNotNullOrWhitespace as isNotNullOrWhitespace_1, isNotNullOrEmpty as isNotNullOrEmpty_1 } from "./Regex.js";
import { parseDecimal, memoize, parseInt$ } from "../Utils.js";
import { Result_Bind, FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { contains, tryFind } from "../fable_modules/fable-library.3.7.20/Seq.js";
import { stringHash } from "../fable_modules/fable-library.3.7.20/Util.js";
import { join, isNullOrEmpty, printf, toText } from "../fable_modules/fable-library.3.7.20/String.js";
import { fold } from "../fable_modules/fable-library.3.7.20/Array.js";
import { contains as contains_1 } from "../fable_modules/fable-library.3.7.20/Set.js";
import { allowedAlphaNumeric } from "./AllowedAlphaNumeric.js";
import { toArray, isEmpty, empty, cons } from "../fable_modules/fable-library.3.7.20/List.js";
import { compare } from "../fable_modules/fable-library.3.7.20/Decimal.js";

export class InputType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Number", "Text", "AlphaNumeric"];
    }
}

export function InputType$reflection() {
    return union_type("Validation.Common.InputType", [], InputType, () => [[], [], []]);
}

export function isEmptyOrRange1to31(getTranslation, str) {
    if (isNotNullOrEmpty_1(str)) {
        const _arg = parseInt$(str);
        if (_arg == null) {
            return new FSharpResult$2(1, getTranslation("Validation.EmptyOrRange1To31"));
        }
        else {
            const x = _arg | 0;
            if (((x >= -1) && (x !== 0)) && (x <= 31)) {
                return new FSharpResult$2(0, str);
            }
            else {
                return new FSharpResult$2(1, getTranslation("Validation.EmptyOrRange1To31"));
            }
        }
    }
    else {
        return new FSharpResult$2(0, str);
    }
}

export function isNotNullOrEmpty(getTranslation, str) {
    if (isNotNullOrEmpty_1(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, getTranslation("Validation.Empty"));
    }
}

export function isNotNullOrWhitespace(getTranslation, str) {
    if (isNotNullOrWhitespace_1(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, getTranslation("Validation.Empty"));
    }
}

export function isPlainText(getTranslation, str) {
    let arg;
    const charType = "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx++++++++++++++++0000000000+++++++AAAAAAAAAAAAAAAAAAAAAAAAAA++++++aaaaaaaaaaaaaaaaaaaaaaaaaa++++xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx................................AABBAAACAAAABBBABBBBBBA.AAAAABBAaacbaaabaaaabbbbbbbbbba.aaaaabbb";
    const invalidChar = tryFind((c_1) => {
        let index;
        return !((index = (c_1.charCodeAt(0) | 0), ((index >= 0) && (index < charType.length)) && contains(charType[index], "0+Aa".split(""), {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        })));
    }, str.split(""));
    if (invalidChar == null) {
        return new FSharpResult$2(0, str);
    }
    else {
        const c_2 = invalidChar;
        return new FSharpResult$2(1, (arg = getTranslation("Validation.PlainText"), toText(printf("%s \u0027%c\u0027"))(arg)(c_2)));
    }
}

export function lengthEQ(getTranslation, length, inputType, str) {
    let arg;
    if (str.length === length) {
        return new FSharpResult$2(0, str);
    }
    else {
        const inputTypeStr = (inputType.tag === 1) ? getTranslation("Validation.Letters") : ((inputType.tag === 2) ? getTranslation("Validation.Characters") : getTranslation("Validation.Numbers"));
        return new FSharpResult$2(1, (arg = getTranslation("Validation.FieldEqual"), toText(printf("%s %i %s."))(arg)(length)(inputTypeStr)));
    }
}

export function lengthLTE(getTranslation, length, inputType, str) {
    let arg;
    if (str.length <= length) {
        return new FSharpResult$2(0, str);
    }
    else {
        const inputTypeStr = (inputType.tag === 1) ? getTranslation("Validation.Letters") : ((inputType.tag === 2) ? getTranslation("Validation.Characters") : getTranslation("Validation.Numbers"));
        return new FSharpResult$2(1, (arg = getTranslation("Validation.FieldLimitMax"), toText(printf("%s %i %s."))(arg)(length)(inputTypeStr)));
    }
}

export function lengthGT(getTranslation, length, inputType, str) {
    let inputTypeStr, arg_3, arg_2, arg_5, arg_4, arg_1, arg, arg_6, inputTypeStr_1, arg_9, arg_8;
    if (str.length > length) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, (length === 0) ? ((inputTypeStr = ((inputType.tag === 1) ? ((arg_3 = getTranslation("Validation.Letter"), (arg_2 = getTranslation("Validation.One"), toText(printf("%s %s"))(arg_2)(arg_3)))) : ((inputType.tag === 2) ? ((arg_5 = getTranslation("Validation.Character"), (arg_4 = getTranslation("Validation.OneAlt"), toText(printf("%s %s"))(arg_4)(arg_5)))) : ((arg_1 = getTranslation("Validation.Number"), (arg = getTranslation("Validation.One"), toText(printf("%s %s"))(arg)(arg_1)))))), (arg_6 = getTranslation("Validation.FieldAtLeast"), toText(printf("%s %s."))(arg_6)(inputTypeStr)))) : ((inputTypeStr_1 = ((inputType.tag === 1) ? getTranslation("Validation.Letters") : ((inputType.tag === 2) ? getTranslation("Validation.Characters") : getTranslation("Validation.Numbers"))), (arg_9 = ((length + 1) | 0), (arg_8 = getTranslation("Validation.FieldAtLeast"), toText(printf("%s %i %s."))(arg_8)(arg_9)(inputTypeStr_1))))));
    }
}

export function isValidEmail(getTranslation, str) {
    let arg;
    if (isValidEmail_1(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, (arg = getTranslation("Validation.ValidEmail"), toText(printf("%s (abc@domain.com)."))(arg)));
    }
}

export function isOnlyNumbers(getTranslation, str) {
    if (isOnlyNumbers_1(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, getTranslation("Validation.OnlyNumbers"));
    }
}

export function isOnlyNumbersOrEmpty(getTranslation, str) {
    if (isNullOrEmpty(str)) {
        return new FSharpResult$2(0, str);
    }
    else if (isOnlyNumbers_1(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, getTranslation("Validation.OnlyNumbers"));
    }
}

export function isOnlyTextAndWhitespace(getTranslation, str) {
    if (isOnlyTextAndWhitespace_1(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, getTranslation("Validation.OnlyLettersSpaces"));
    }
}

export function isPositiveInteger(getTranslation, str) {
    let arg;
    if (isOnlyPositiveInteger(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, (arg = getTranslation("Validation.OnlyIntegers"), toText(printf("%s (1,2,3...)."))(arg)));
    }
}

export function isPeppolId(getTranslation, str) {
    let arg;
    if (isValidPeppolId(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, (arg = getTranslation("Validation.ValidPeppol"), toText(printf("%s (123:456)."))(arg)));
    }
}

export function isOnlyNumberWithPossibleDecimals(getTranslation, str) {
    let arg;
    if (isOnlyNumberWithPossibleDecimals_1(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, (arg = getTranslation("Validation.UnsupportedNumberFormat"), toText(printf("%s (123.45 || 123)"))(arg)));
    }
}

const isAllowedAlphaNumeric$0027 = memoize((str) => {
    const _arg = fold((disallowedCharacters, current) => {
        if (contains_1(current, allowedAlphaNumeric)) {
            return disallowedCharacters;
        }
        else {
            return cons(current, disallowedCharacters);
        }
    }, empty(), str.split(""));
    return isEmpty(_arg) ? (new FSharpResult$2(0, void 0)) : (new FSharpResult$2(1, _arg));
});

export function isAllowedAlphaNumeric(getTranslation, str) {
    let arg_1;
    const _arg = isAllowedAlphaNumeric$0027(str);
    if (_arg.tag === 1) {
        const problemStr = join("", toArray(_arg.fields[0]));
        return new FSharpResult$2(1, (arg_1 = getTranslation("Validation.DisallowedCharacters"), toText(printf("%s (%s)"))(arg_1)(problemStr)));
    }
    else {
        return new FSharpResult$2(0, str);
    }
}

export function isValidJSON(str) {
    try {
        JSON.parse(str);
        return new FSharpResult$2(0, str);
    }
    catch (e) {
        return new FSharpResult$2(1, e.message);
    }
}

export function isValidJSONOrEmpty(str) {
    if (str === "") {
        return new FSharpResult$2(0, str);
    }
    else {
        return isValidJSON(str);
    }
}

export function is_yyyy_mm_dd(getTranslation, str) {
    if (is_yyyy_mm_dd_1(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, getTranslation("Validation.ShortDateFormat"));
    }
}

export function is_yyyy_mm_dd_hh_mm_ss(getTranslation, str) {
    if (is_yyyy_mm_dd_hh_mm_ss_1(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, getTranslation("Validation.LongDateFormat"));
    }
}

export function isSQLBoolean(getTranslation, str) {
    if (isSQLBoolean_1(str)) {
        return new FSharpResult$2(0, str);
    }
    else {
        return new FSharpResult$2(1, getTranslation("Validation.SQLBoolean"));
    }
}

export function numberIsBetween(getTranslation, fromNumber, toNumber, str) {
    let number, arg, arg_3;
    const matchValue = parseDecimal(str);
    if (matchValue == null) {
        return new FSharpResult$2(1, getTranslation("Validation.OnlyNumbers"));
    }
    else if ((number = matchValue, (compare(number, fromNumber) >= 0) && (compare(number, toNumber) <= 0))) {
        const number_3 = matchValue;
        return new FSharpResult$2(0, str);
    }
    else if (compare(matchValue, toNumber) > 0) {
        const number_4 = matchValue;
        return new FSharpResult$2(1, (arg = getTranslation("Validation.FieldLimitMax"), toText(printf("%s %M"))(arg)(toNumber)));
    }
    else if (compare(matchValue, fromNumber) < 0) {
        const number_5 = matchValue;
        return new FSharpResult$2(1, (arg_3 = getTranslation("Validation.FieldAtLeast"), toText(printf("%s %M"))(arg_3)(fromNumber)));
    }
    else {
        const number_6 = matchValue;
        return new FSharpResult$2(1, getTranslation("Validation.UnsupportedNumberFormat"));
    }
}

export class AlphaNumeric40 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AlphaNumeric40"];
    }
}

export function AlphaNumeric40$reflection() {
    return union_type("Validation.Common.AlphaNumeric40", [], AlphaNumeric40, () => [[["Item", string_type]]]);
}

export function AlphaNumeric40Module_create(getTranslation, str) {
    const _arg = Result_Bind((str_2) => lengthLTE(getTranslation, 40, new InputType(2), str_2), isNotNullOrEmpty(getTranslation, str));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new AlphaNumeric40(0, _arg.fields[0]));
    }
}

export function AlphaNumeric40Module_value(_arg) {
    return _arg.fields[0];
}

export class String40 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String40"];
    }
}

export function String40$reflection() {
    return union_type("Validation.Common.String40", [], String40, () => [[["Item", string_type]]]);
}

export function String40Module_create(getTranslation, str) {
    const _arg = Result_Bind((str_2) => lengthLTE(getTranslation, 40, new InputType(1), str_2), isNotNullOrEmpty(getTranslation, str));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new String40(0, _arg.fields[0]));
    }
}

export function String40Module_value(_arg) {
    return _arg.fields[0];
}

export class String32OrEmpty extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String32OrEmpty"];
    }
}

export function String32OrEmpty$reflection() {
    return union_type("Validation.Common.String32OrEmpty", [], String32OrEmpty, () => [[["Item", string_type]]]);
}

export function String32OrEmptyModule_create(getTranslation, str) {
    const _arg = lengthLTE(getTranslation, 32, new InputType(1), str);
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new String32OrEmpty(0, _arg.fields[0]));
    }
}

export function String32OrEmptyModule_value(_arg) {
    return _arg.fields[0];
}

export class Number8 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Number8"];
    }
}

export function Number8$reflection() {
    return union_type("Validation.Common.Number8", [], Number8, () => [[["Item", string_type]]]);
}

export function Number8Module_create(getTranslation, str) {
    const _arg = Result_Bind((str_3) => isOnlyNumbers(getTranslation, str_3), Result_Bind((str_2) => lengthLTE(getTranslation, 8, new InputType(0), str_2), isNotNullOrEmpty(getTranslation, str)));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new Number8(0, _arg.fields[0]));
    }
}

export function Number8Module_value(_arg) {
    return _arg.fields[0];
}

export class String12OrEmpty extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String12OrEmpty"];
    }
}

export function String12OrEmpty$reflection() {
    return union_type("Validation.Common.String12OrEmpty", [], String12OrEmpty, () => [[["Item", string_type]]]);
}

export function String12OrEmptyModule_create(getTranslation, str) {
    const _arg = lengthLTE(getTranslation, 12, new InputType(1), str);
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new String12OrEmpty(0, _arg.fields[0]));
    }
}

export function String12OrEmptyModule_value(_arg) {
    return _arg.fields[0];
}

export class String40OrEmpty extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String40OrEmpty"];
    }
}

export function String40OrEmpty$reflection() {
    return union_type("Validation.Common.String40OrEmpty", [], String40OrEmpty, () => [[["Item", string_type]]]);
}

export function String40OrEmptyModule_create(getTranslation, str) {
    const _arg = lengthLTE(getTranslation, 40, new InputType(1), str);
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new String40OrEmpty(0, _arg.fields[0]));
    }
}

export function String40OrEmptyModule_value(_arg) {
    return _arg.fields[0];
}

export class String30OrEmpty extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String30OrEmpty"];
    }
}

export function String30OrEmpty$reflection() {
    return union_type("Validation.Common.String30OrEmpty", [], String30OrEmpty, () => [[["Item", string_type]]]);
}

export function String30OrEmptyModule_create(getTranslation, str) {
    const _arg = lengthLTE(getTranslation, 30, new InputType(1), str);
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new String30OrEmpty(0, _arg.fields[0]));
    }
}

export function String30OrEmptyModule_value(_arg) {
    return _arg.fields[0];
}

export class EmptyOrRange1To31 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["EmptyOrRange1To31"];
    }
}

export function EmptyOrRange1To31$reflection() {
    return union_type("Validation.Common.EmptyOrRange1To31", [], EmptyOrRange1To31, () => [[["Item", string_type]]]);
}

export function EmptyOrRange1To31Module_create(getTranslation, str) {
    const _arg = isEmptyOrRange1to31(getTranslation, str);
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new EmptyOrRange1To31(0, _arg.fields[0]));
    }
}

export function EmptyOrRange1To31Module_value(_arg) {
    return _arg.fields[0];
}

